import { configureStore } from "@reduxjs/toolkit";
import authSlice, { sessionExpired, tokenRefreshed } from "./auth/authSlice";
import { setAuthSessionHandlers } from "utils/authSession";
import resultScoreSlice from "./resultScore/resultScoreSlice";
// import { needAttentionApi } from "api/needAttentionApi";
import { api } from "api/api";
import dealershipSlice from "./dealership/dealershipSlice";
const store = configureStore({
    reducer: {
        auth: authSlice,
        resultScore: resultScoreSlice,
        dealerships: dealershipSlice,
        [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware().concat(
            api.middleware,
        )
});

// Lets the HTTP clients (RTK Query, axiosInstance, fetchUtil) update or end
// the session when a request gets a 401.
setAuthSessionHandlers({
    onSessionExpired: () => {
        if (store.getState().auth.accessToken) {
            store.dispatch(sessionExpired());
        }
    },
    onTokenRefreshed: (accessToken) => {
        store.dispatch(tokenRefreshed(accessToken));
    },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch


export default store;